export const upsellings = {
    text1: "الخدمات",
    text2: "أدِر خدماتك",
    text3: "قائمة الخدمات",
    text4: "المورّدون",
    text5: "قائمة الخدمات التي سيراها نزلاؤك",
    text6: "تسجيل خدمة",
    text7: "الاسم",
    text8: "تاريخ الإنشاء",
    text9: "الحالة",
    text10: "مفعّلة",
    text11: "غير مفعّلة",
    text12: "تعديل الخدمة",
    text13: "حذف الخدمة",
    text14: "لم يُعثر على أي خدمة.",
    text15: "تم التغيير بنجاح.",
    text16: "هل تريد بالتأكيد حذف الخدمة",
    text17: "ستفقد بياناتك المحفوظة",
    text18: "حذف الخدمة",
    text19: "إلغاء",
    text20: "تم الحذف بنجاح.",
    text21: "إنشاء خدمة",
    text22: "معلومات الخدمة",
    text23: "أدخِل معلومات الخدمة الأساسية التي تظهر في البطاقة.",
    text24: "كل وحدات الإقامة",
    text25: "اختر وحدة الإقامة *",
    text26: "أدخِل الاسم",
    text27: "اسم خدمتك *",
    text28: "تلقائي",
    text29: "يدوي",
    text30: "نوع التأكيد",
    text31: "عنوان الخدمة",
    text32: "أدخِل العنوان *",
    text33: "تسجيل الوصول/المغادرة",
    text34: "خدمة النقل",
    text35: "F&B",
    text36: "موسمية",
    text37: "عائلية",
    text38: "رومانسية",
    text39: "SPA والصحة",
    text40: "الفن والثقافة",
    text41: "الأنشطة",
    text42: "الخدمات",
    text43: "أخرى",
    text44: "الفئة *",
    text45: "خدمة داخلية",
    text46: "المورّد *",
    text47: "الوصف",
    text48: "أدخِل وصف خدمتك *",
    text49: "السعر",
    text50: "اختر نوع السعر وحدِّد المبلغ الذي سيدفعه نزلاؤك مقابل العرض.",
    text51: "أدخِل الرقم",
    text52: "لكل وحدة",
    text53: "لكل شخص",
    text54: "لكل مجموعة",
    text55: "لكل يوم",
    text555: "لكل ساعة",
    text56: "السعر لكل",
    text57: "الصورة",
    text58: "ارفع صورة ستظهر في أعلى البطاقة.",
    text59: "حفظ الخدمة",
    text60: "جارٍ التحميل ...",
    text61: "تم إنشاء الخدمة بنجاح.",
    text62: "قائمة المورّدين",
    text63: "إضافة مورّد",
    text64: "المعرّف",
    text65: "الاسم",
    text66: "البريد الإلكتروني",
    text67: "الهاتف",
    text68: "تعديل المورّد",
    text69: "حذف المورّد",
    text70: "تسجيل مورّد",
    text71: "أضِف ",
    text72: "مورّدين ",
    text73: "إلى قائمتك لتتمكّن من استخدامهم في إنشاء عروض جديدة.",
    text74: "أدخِل الاسم",
    text75: "اسم المورّد *",
    text76: "الدولة",
    text77: "خطأ",
    text78: "أدخِل رقمك",
    text79: "الهاتف *",
    text80: "عنوان البريد الإلكتروني *",
    text81: "العنوان",
    text82: "إضافة مورّد",
    text83: "تم الإنشاء بنجاح.",
    text84: "هل تريد بالتأكيد حذف المورّد؟",
    text85: "ستفقد بياناتك المحفوظة",
    text86: "حذف المورّد",
    text87: "تم الحذف بنجاح.",
    text96: 'أدِر اشتراكاتك وفواتيرك',
    
    // Correcciones 
    p1: "السعر عند الاستفسار",
};